//import Cookies from 'js-cookie'
import store from '@/store'

const setting = {
  state: {
    ruby: {
      value: !+localStorage.getItem('setting.ruby') ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    reference: {
      value: !+localStorage.getItem('setting.reference') ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    annotation: {
      value: !+localStorage.getItem('setting.annotation') ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    subheading: {
      value: !+localStorage.getItem('setting.subheading') ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    apocrypha: {
      value: !+localStorage.getItem('setting.apocrypha') ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    fontSize: {
      value: !+localStorage.getItem('setting.fontSize') ? 1 : parseInt(localStorage.getItem('setting.fontSize')),
      min: 0,
      max: 10,
    },
    vspace: {
      value: !+localStorage.getItem('setting.vspace') ? 5 : parseInt(localStorage.getItem('setting.vspace')),
      min: 0,
      max: 10,
    },
  },
  mutations: {
    SETTING_TOGGLE_RUBY: (state, value) => {
      if (typeof value === undefined) {
        state.ruby.value = !state.ruby.value
      } else {
        state.ruby.value = value
      }
      localStorage.setItem('setting.ruby', state.ruby.value)
    },

    SETTING_TOGGLE_REFERENCE: (state, value) => {
      if (typeof value === undefined) {
        state.reference.value = !state.reference.value
      } else {
        state.reference.value = value
      }
      localStorage.setItem('setting.reference', state.reference.value)
    },
    
    SETTING_TOGGLE_ANNOTATION: (state, value) => {
      if (typeof value === undefined) {
        state.annotation.value = !state.annotation.value
      } else {
        state.annotation.value = value
      }
      localStorage.setItem('setting.annotation', state.annotation.value)
    },
   
    SETTING_TOGGLE_SUBHEADING: (state, value) => {
      if (typeof value === undefined) {
        state.subheading.value = !state.subheading.value
      } else {
        state.subheading.value = value
      }
      localStorage.setItem('setting.subheading', state.subheading.value)
    },

    SETTING_TOGGLE_APOCRYPAH: (state, value) => {
      if (typeof value === undefined) {
        state.apocrypha.value = !state.apocrypha.value
      } else {
        state.apocrypha.value = value
      }
      localStorage.setItem('setting.apocrypha', state.apocrypha.value)
    },

    SETTING_CHANGE_FONT_SIZE: (state, value) => {
      state.fontSize.value = value
      localStorage.setItem('setting.fontSize', state.fontSize.value)
    },

    SETTING_CHANGE_VSPACE: (state, value) => {
      state.vspace.value = value
      localStorage.setItem('setting.vspace', state.vspace.value)
    },
  },

  actions: {
    settingToggleRuby: ({ commit }, value) => {
      commit('SETTING_TOGGLE_RUBY', value)
    },

    settingToggleReference: ({ commit }, value) => {
      commit('SETTING_TOGGLE_REFERENCE', value)
    },

    settingToggleAnnotation: ({ commit }, value) => {
      commit('SETTING_TOGGLE_ANNOTATION', value)
    },

    settingToggleSubheading: ({ commit }, value) => {
      commit('SETTING_TOGGLE_SUBHEADING', value)
    },

    settingToggleApocrypha: ({ commit }, value) => {
      commit('SETTING_TOGGLE_APOCRYPAH', value)
      store.dispatch('dataSetBibleSearchBookCode', store.state.data.search.bookCode)
    },

    settingChangeFontSize: ({ commit }, value) => {
      commit('SETTING_CHANGE_FONT_SIZE', value)
    },

    settingChangeVSpace: ({ commit }, value) => {
      commit('SETTING_CHANGE_VSPACE', value)
    },
  }
}

export default setting
